// extracted by mini-css-extract-plugin
export default {"container":"DateTime_container__jTTOX","input":"DateTime_input__7NgQ9","label":"DateTime_label__5BXNh","borderLabel":"DateTime_borderLabel__+QXVF","icon":"DateTime_icon__rz3XW"};